import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {StorageService} from "./storage.service";

const API_URL = environment.apiUrl + 'integrations/';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) { }

  getIntegrations() {
    return new Promise((resolve) => {
      const integrations = this.storageService.getIntegrations();
      if (integrations) {
        resolve(integrations);
      } else {
        this.http.get(API_URL + '', {responseType: 'json'}).subscribe((data) => {
          this.storageService.saveIntegrations(data);
          resolve(data);
        });
      }
    });
  }

}
